module.exports = __webpack_public_path__ + "img/cover-img.9b9a4af0.png";